import {Component, EventEmitter, OnInit} from '@angular/core';
import {UntypedFormControl, Validators} from '@angular/forms';
import {MDBModalRef} from 'ng-uikit-pro-standard';
import {take} from 'rxjs/operators';
import {ChecklistsService} from '../../../../common/services/checklists.service';
import {Localization} from '../../../../common/enums/localization';
import {ChecklistNode} from '../../checklist/model/checklist-node';

@Component({
  selector: 'app-rename-checklist-modal',
  templateUrl: './rename-checklist-modal.component.html',
  styleUrls: ['./rename-checklist-modal.component.scss']
})
export class RenameChecklistModal implements OnInit {
  public readonly Localization = Localization;
  public isBusy = false;
  public node: ChecklistNode;

  public readonly checklistLabelField = new UntypedFormControl(null, [Validators.required]);

  private readonly updatedNode$ = new EventEmitter<ChecklistNode>();
  public readonly onNodeUpdated = this.updatedNode$.pipe(take(1)).toPromise();

  constructor(
      private readonly checklistsService: ChecklistsService,
      private readonly self: MDBModalRef,
  ) { }


  public ngOnInit() {
    this.checklistLabelField.patchValue(this.node.label);
  }

  public close(){
    this.self.hide();
    this.updatedNode$.emit(this.node);
  }

  public async onSubmit() {
    const updatedNode = await this.updateChecklist();
    this.updatedNode$.emit(updatedNode);
    this.close();
  }

  private async updateChecklist() {
    const updatedNode = {
      ...this.node,
      label: this.checklistLabelField.value,
    } as ChecklistNode;
    this.isBusy = true;
    try {
      await this.checklistsService.updateNode(updatedNode, true).toPromise();
      return updatedNode;
    } finally {
      this.isBusy = false;
    }
  }

}
